const AppName = 'Voyager'

export default AppName
